/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Required_BadgeInputs */

const en_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const fr_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requis`)
};

const de_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

const it_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessario`)
};

const ru_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимый`)
};

const es_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerido`)
};

const zh_cn2_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必需的`)
};

const ja_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必須`)
};

const hi_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवश्यक`)
};

const pt_pt2_merge_event_group_required_badge = /** @type {(inputs: Merge_Event_Group_Required_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigatório`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Merge_Event_Group_Required_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_required_badge = /** @type {((inputs?: Merge_Event_Group_Required_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Required_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_required_badge(inputs)
	if (locale === "de") return de_merge_event_group_required_badge(inputs)
	if (locale === "it") return it_merge_event_group_required_badge(inputs)
	if (locale === "ru") return ru_merge_event_group_required_badge(inputs)
	if (locale === "es") return es_merge_event_group_required_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_required_badge(inputs)
	if (locale === "ja") return ja_merge_event_group_required_badge(inputs)
	if (locale === "hi") return hi_merge_event_group_required_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_required_badge(inputs)
	return en_merge_event_group_required_badge(inputs)
});